import * as React from 'react';
import { getMediaManagerUrl } from '../MediaManagerImage';
import { MAX_SIZE, deNormalizePhotoDimensions, normalizePhotoDimensions, } from './utils';
import PhotoEditor from '../PhotoEditor';
import config from '../config';
const MediaManagerPhotoEditor = ({ picture, onSubmit, onClose, picture: { dimensions }, availableAspectRatios = ['2:1', '4:3', '16:9', '1:1', null], mask, }) => {
    const [naturalWidth, setNaturalWidth] = React.useState(null);
    const [naturalHeight, setNaturalHeight] = React.useState(null);
    React.useEffect(() => {
        const loadImageDimensions = async (imageUri) => {
            const img = new Image();
            img.src = imageUri;
            return new Promise(resolve => {
                img.addEventListener('load', (e) => {
                    const { target: { naturalHeight, naturalWidth }, } = e;
                    setNaturalHeight(naturalHeight);
                    setNaturalWidth(naturalWidth);
                    resolve();
                });
            });
        };
        (async () => {
            let imageUrl = `${config.MEDIAMANAGER_URL}/media/${picture.uri}`;
            if (picture.public_url) {
                imageUrl = picture.public_url;
            }
            await loadImageDimensions(imageUrl);
        })();
    }, [picture]);
    const handleSubmit = data => {
        onSubmit(normalizePhotoDimensions(data, naturalWidth, naturalHeight));
    };
    const pictureWithoutDimensions = { ...picture };
    delete pictureWithoutDimensions['dimensions'];
    const deNormalizedDimensions = (() => {
        if (dimensions) {
            return deNormalizePhotoDimensions({
                x: dimensions.X,
                y: dimensions.Y,
                width: dimensions.W,
                height: dimensions.H,
            }, naturalWidth, naturalHeight);
        }
        return void 0;
    })();
    if (dimensions && !naturalWidth && !naturalHeight) {
        return null;
    }
    return (React.createElement(PhotoEditor, { src: getMediaManagerUrl(pictureWithoutDimensions, MAX_SIZE, MAX_SIZE, 'resize'), onClose: onClose, onSubmit: handleSubmit, viewMode: 1, data: deNormalizedDimensions, availableAspectRatios: availableAspectRatios, mask: mask }));
};
export default MediaManagerPhotoEditor;
